import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandOldOrder = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/brand/api/secure/v1/old-order/' +
      brandId +
      '/order',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};